import clsx from "clsx";
import { useState } from "react";
import AnimatedContent from "../AnimatedContent";

const Item = ({ question, answer }: { question: string, answer: string }) => {
    const [open, setOpen] = useState(false);
    return <div
        className={clsx(
            "flex flex-col p-[24px] border border-[#161616] rounded-[12px] w-full transition-all duration-300 ease-in-out cursor-pointer",
            "md:w-[674px]",
            open ? 'gap-[12px] bg-[#161616]' : 'gap-[0px]'
        )}
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
    >
        <div className="flex justify-between items-center">
            <div className="text-[20px] font-medium leading-[1.2] tracking-[-0.8px]">{question}</div>
            <button
                className="relative w-[20px] h-[20px] flex items-center justify-center"
            >
                <div className={`w-[12px] h-[2px] bg-[#00FFEE] rounded-full transition-transform duration-300 ease-in-out  ${!open ? 'rotate-90' : 'rotate-0'}`} />
                <div className={`w-[12px] h-[2px] bg-[#00FFEE] rounded-full absolute transition-transform duration-300 ease-in-out`} />
            </button>
        </div>
        <div className={`text-[14px] text-white/70 transition-all duration-300 ease-in-out overflow-hidden ${!open ? 'max-h-0' : 'max-h-[51px]'}`}>{answer}</div>
    </div>;
};
const FrequentlyAskQuestions = () => {
    return <div className="flex flex-col items-center gap-[40px] pt-[120px] px-[16px]">
        <div className={clsx(
            "flex flex-col items-center gap-[16px]",
            "md:gap-[24px]"
        )}>
            <div className={clsx(
                "text-[32px] font-semibold leading-[1.2] tracking-[-1.28px] text-center",
                "md:text-[46px] md:tracking-[-1.84px]"
            )}>
                <AnimatedContent>
                    Frequently Asked Questions
                </AnimatedContent>
            </div>
            <div className="text-[14px] text-white/70 leading-[1.5] tracking-[-0.64px] text-center">
                <AnimatedContent>
                    Questions? We've got answers.
                </AnimatedContent>
            </div>
        </div>
        <div className="flex flex-col gap-[12px]">
            <Item question="Can I withdraw my TAO anytime?" answer="Yes. Depositor funds are fully liquid and can be withdrawn at any time, subject only to standard block finality." />
            <Item question="How is yield generated on TaoFlow?" answer="Yield comes from two sources: (1) TAO staked to the root subnet, and (2) profit-sharing from successful leveraged trades executed by borrowers.." />
            <Item question="What happens if a trader loses money?" answer="Losses are first absorbed by the trader's collateral. Depositor funds are never exposed to trader downside." />
            <Item question="How much can traders borrow?" answer="Traders can borrow up to 10x their posted collateral to stake into high-performing subnet alpha tokens." />
            <Item question="Is TaoFlow audited?" answer="Yes. TaoFlow's smart contracts have been audited by leading security firms, and a public bug bounty is live to encourage continuous security review." />
            <Item question="Do I need TAO to use the platform?" answer="Yes. TAO is the native asset for deposits, borrowing, and trading. You'll need TAO in your wallet to interact with the protocol." />
        </div>
    </div>;
};

export default FrequentlyAskQuestions;
